import { useEffect, useState } from 'react';

/**
 * Delays the state update by certain amount of milliseconds
 */
const useDelayedState = <T>(state: T, delay: number = 1000) => {
  const [delayedState, setDelayedState] = useState<T>(state);

  useEffect(() => {
    const timeout = setTimeout(() => setDelayedState(state), delay);

    return () => clearTimeout(timeout);
  }, [state, delay]);

  return delayedState;
};

export default useDelayedState;
